import React from 'react';
import { BiSolidHomeSmile } from 'react-icons/bi';
import { FaUser } from 'react-icons/fa6';
import { FiHeart, FiShoppingBag } from 'react-icons/fi';
import { Link, useLocation } from 'react-router-dom';
import { useGlobal } from '../../global/GlobalContext';

const TABS = [
  { to: '/', label: 'Home', icon: BiSolidHomeSmile, exact: true },
  { to: '/wishlist', label: 'Wishlist', icon: FiHeart, countKey: 'wishlist' },
  { to: '/cart', label: 'Cart', icon: FiShoppingBag, countKey: 'cart' },
  { to: '/myaccount', label: 'Profile', icon: FaUser },
];

const BottomFixedNav = () => {
  const location = useLocation();
  const { wishlist, cartLength } = useGlobal();

  const counts = { wishlist: wishlist?.length || 0, cart: cartLength || 0 };

  return (
    <div className='block md:hidden'>
      <div className='fixed bottom-0 left-0 z-50 w-full px-2 py-2 bg-white border-t border-gray-100 shadow-[0_-4px_12px_rgba(0,0,0,0.04)]'>
        <div className='flex justify-between items-center'>
          {TABS.map(({ to, label, icon: Icon, exact, countKey }) => {
            const isActive = exact ? location.pathname === to : location.pathname.startsWith(to);
            const count = countKey ? counts[countKey] : 0;
            return (
              <Link
                key={to}
                to={to}
                className={`relative flex flex-1 items-center flex-col gap-1 py-1 transition-colors ${isActive ? 'text-brand-600' : 'text-gray-400'}`}
              >
                <span className="relative">
                  <Icon className="text-xl" />
                  {count > 0 && (
                    <span className="absolute -top-1.5 -right-2 text-[9px] font-bold text-white bg-badge-orange rounded-full w-4 h-4 flex items-center justify-center">
                      {count}
                    </span>
                  )}
                </span>
                <span className={`text-[10px] font-semibold ${isActive ? 'text-brand-600' : 'text-gray-500'}`}>
                  {label}
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default BottomFixedNav;
